/** @format */

import {Modal, ModalHeader, ModalFooter} from '@sttark/design-system';
import {useDuplicateOrder} from '../shared/use_duplicate_order';
import {Button} from '@sttark/design-system';
import {IfElse} from 'frontier-utilities';
import {useState} from 'react';
import React from 'react';

export function ConvertQuoteToNewOrderButton({id, children}) {
    const {isPending, success, handleDuplicate} = useDuplicateOrder(id);
    const [isOpen, setIsOpen] = useState(false);

    const childWithOnClick = React.Children.map(children, child =>
        React.cloneElement(child, {
            onClick: () => setIsOpen(true)
        })
    );

    return (
        <>
            <Modal isOpen={isOpen} onClose={() => setIsOpen(false)} bodyHeightAuto>
                <ModalHeader>Edit as New Order</ModalHeader>
                <div>
                    <h4 className="mb-4 mt-0 mx-0" style={{fontSize: 18}}>
                        You will be taken back to the Quoter.
                    </h4>
                    <p className="m-0 p-0">
                        From there, you can edit all details of this item. Changes to this cart item
                        will be automatically saved and the item will be updated in the cart.
                    </p>
                </div>
                <ModalFooter>
                    <div className="d-flex align-items-center justify-content-end gap-4">
                        <Button onClick={() => setIsOpen(false)} label="Cancel" secondary small />

                        <IfElse condition={!isPending}>
                            <Button
                                label={'Create New Order'}
                                onClick={handleDuplicate}
                                primary
                                small
                            />
                            <Button
                                label={!success ? 'Creating...' : 'Redirecting...'}
                                onClick={() => {}}
                                disabled
                                primary
                                small
                            />
                        </IfElse>
                    </div>
                </ModalFooter>
            </Modal>

            <IfElse condition={!!children}>
                <>{childWithOnClick}</>
                <Button
                    onClick={() => setIsOpen(true)}
                    label="Convert to New Order"
                    disabled={isPending}
                    primary
                    small
                />
            </IfElse>
        </>
    );
}
